import axios from "axios";
import { requestError } from "../utils/RequestError";

export const getListBooking = async (params) => {
  try {
    const res = await axios.get(`/admin/bookings`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const getBookingById = async (id) => {
  try {
    const res = await axios.get(`/admin/bookings/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};
